import {useState} from 'react';
import {ACCOUNT_ID} from '../../api/account';
import {createLinkToken} from '../../api/accountLink';
import {getYandexClientId} from '../../utils/analytics';
import {showError} from '../../utils/notify';

const PLATFORM_LABEL = {
    telegram: 'Telegram',
    max: 'MAX',
};

export default function LinkAccountButton({platform, isLinked, size = 'md'}) {
    const [loading, setLoading] = useState(false);
    const label = PLATFORM_LABEL[platform] || platform;

    const sizeClass = size === 'sm'
        ? 'px-4 py-2 text-sm'
        : 'px-5 py-2.5 text-sm';

    if (isLinked) {
        return (
            <span
                className={`${sizeClass} bg-brand-gray text-brand-dark/70 font-medium rounded-xl inline-flex items-center`}
            >
                ✓ Привязан к {label}
            </span>
        );
    }

    const onClick = async () => {
        if (loading) return;
        setLoading(true);
        try {
            const yandexClientId = await getYandexClientId();
            const {deep_link} = await createLinkToken({
                accountId: ACCOUNT_ID,
                platform,
                yandexClientId,
            });
            window.open(deep_link, '_blank', 'noopener,noreferrer');
        } catch (e) {
            console.error(e);
            showError('Не удалось создать ссылку. Попробуйте ещё раз.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <button
            onClick={onClick}
            disabled={loading}
            className={`${sizeClass} bg-gradient-to-r from-brand-red via-brand-pink to-brand-orange text-white font-semibold rounded-xl hover:opacity-95 transition disabled:opacity-50`}
        >
            {loading ? 'Готовим…' : `Привязать к ${label}`}
        </button>
    );
}
